export const ROLES = Object.freeze({
  CONTENT_CREATOR: "CONTENT_CREATOR",
  ADMIN: "ADMIN",
  SUB_ADMIN: "SUB_ADMIN",
});

export const CONTENT_STATUS = {
  DRAFT: "DRAFT",  
  IN_REVIEW: "IN_REVIEW", 
  CHANGES_REQUESTED: "CHANGES_REQUESTED",
  APPROVED: "APPROVED",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED", 
  REJECTED: 'REJECTED'
};

export const CONTENT_TIER = {
  FREE: 'FREE',
  PREMIUM: 'PREMIUM',
  PPV: 'PAYPERVIEWS'
};

/** Map API/legacy strings (e.g. "Premium") to CONTENT_TIER values for controlled selects. */
export function normalizeContentTier(raw) {
  if (raw == null || raw === "") return "";
  const s = String(raw).trim().toUpperCase().replace(/\s+/g, "");
  if (s === "FREE") return CONTENT_TIER.FREE;
  if (s === "PREMIUM") return CONTENT_TIER.PREMIUM;
  if (s === "PAYPERVIEWS" || s === "PAYPERVIEW") return CONTENT_TIER.PPV;
  return "";
}
